module.exports = __webpack_public_path__ + "img/photo-collage-desktop.b3dab728.jpg";